import {get} from '../api.utils';

export class ZbeApi {
    constructor() {
    }

    async getzbe(): Promise<any> {
        const data = await get<any>(`/zbe`, false, '/geoservices');
        return data;
    }

    async getOtherzbe(): Promise<any> {
        const data = await get<any>(`/zbe_municipalities`, false, '/geoservices');
        return data;
    }

/*     async getFreeRoadszbe(): Promise<any> {
        const data = await get<any>(`/zbe_free_roads`, false, '/geoservices');
        return data;
    } */
}
